import * as getter from '../types/getters'
import * as action from '../types/actions'
import linq from 'linq'
import { classValidate } from '../../utility/validateUtility'
import Form from 'vform'
import { buildQuery } from '../../utility/stringUtility'
import store from '../../store'
import Collection from '../../models/Collection'

export const state = {
    collections: [],
}

export const mutations = {
    [action.FETCH_COLLECTIONS](state, collections) {
        state.collections = collections
    },
}

export const actions = {
    async [action.FETCH_COLLECTIONS]({ commit }) {
        const query = buildQuery(store.state.route.query)
        const { data } = await axios.get(`/api/collections?${query}`)
        const collections = linq
            .from(data)
            .select((x) => new Collection(x))
            .toArray()
        commit(action.FETCH_COLLECTIONS, collections)
    },
}

export const getters = {
    [getter.COLLECTIONS]: (state) => state.collections,
}

export default {
    state,
    mutations,
    actions,
    getters,
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/collections.js